import React                from 'react';
import PropTypes            from 'prop-types';
import TextBadgesList       from './../Base/Badges/TextBadgesList';
import Translations         from '../../../../utils/Translations';
import Flux                 from './../../../../flux/Flux';
import {mergeDeep}          from './../../../../utils/CommonUtils';
import {ModelInterviewType} from './InterviewTilePropTypes';

const TextBadgeStyles     = Flux.Constants.Grid2.TextBadge.Styles;
const TextBadgeFontColors = Flux.Constants.Grid2.TextBadge.FontColors;

const InterviewTileTextBadgesList = props => {
	const data   = props.data;
	const config = mergeDeep({}, InterviewTileTextBadgesList.defaultProps.config, props.config);

	const textBadges = [];

	if (config.show.interview) {
		textBadges.push({
			parts: [{
				text: Translations.get('BadgeInterview'),
			}],
			style: TextBadgeStyles.HIGHLIGHT,
		});
	}

	if (config.show.fsk18 && typeof data.ageRating === 'number' && data.ageRating >= 18) {
		textBadges.push({
			parts: [{
				text: Translations.get('Over18'),
			}],
			style: TextBadgeStyles.HIGHLIGHT,
		});
	}

	if (config.show.vip && data.vip) {
		textBadges.push({
			parts: [{
				text:  Translations.get('VideoGridVip'),
				icon:  '-icon-person-vip',
				color: TextBadgeFontColors.BLACK,
			}],
			style: TextBadgeStyles.GOLD,
		});
	}

	return <TextBadgesList textBadges={textBadges} />;
};

export const InterviewTileTextBadgesListConfigType = PropTypes.shape({
	show: PropTypes.shape({
		fsk18:     PropTypes.bool,
		interview: PropTypes.bool,
		vip:       PropTypes.bool,
	}),
});

InterviewTileTextBadgesList.propTypes = {
	data:   ModelInterviewType.isRequired, // VXQL ModelInterview type
	config: InterviewTileTextBadgesListConfigType,
};

InterviewTileTextBadgesList.defaultProps = {
	config: {
		show: {
			fsk18:     true,
			interview: true,
			vip:       true,
		},
	},
};

export default InterviewTileTextBadgesList;
